/*
*
* File JS componente Header
*
*/

// IMPORT MODULES
//--------------------------------------------------------------------//

import Headroom from "headroom.js";



// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import './header.scss';

//--------------------------------------------------------------------//


/**
*	Script per il componente Header
*
*
*	@since  0.0.1
*	@author Ignazio Stagnitta - IM*MEDIA
*
*	@return {void}
*/
const header = () =>
{
    const headerExpanded = window.IM_GLOBAL.resolutions.headerExpanded|1024;
    const tabletPortrait = window.IM_GLOBAL.resolutions.tabletPortrait|768;
    let isMobile = window.innerWidth < tabletPortrait ? true : false;
    let isExpanded = window.innerWidth >= headerExpanded ? true : false;

    /* Individuiamo dal DOM tutti gli elementi dell'header
    --------------------------------------------------------------------------*/
    const context = document.querySelector('#header');
    if( context === null ) return false;


    /* Headroom, gestione scroll e posizione
    --------------------------------------------------------------------------*/
    
    let headroom  = new Headroom(context,
    {
        offset : 280,
        onTop: function()
        {
            context.classList.add('transition-on');
        },
        onNotTop: function()
        {
            context.classList.add('transition-on');
        },
    });

    headroom.init();


    /* Menu e megamenu
    --------------------------------------------------------------------------*/
    const burgermenu = context.querySelector('.header__burger');


    /*/ Al click sul Burgermenu
    --------------------------------------------------------------------------*/
    if( burgermenu )
    {
        burgermenu.addEventListener('click', e=>
        {
            context.classList.add('transition-on');
            context.classList.toggle('mainmenu-opened');
        });
    }


    /*/ Funzioni menu
    --------------------------------------------------------------------------*/
    function flushHeader()
    {
        context.classList.remove
        (
            'mainmenu-opened',
            'search-is-open'
        );
    }


    /* On Screen Media Query
    --------------------------------------------------------------------------*/
    function resize(mediaQuery)
    {
        flushHeader();
        context.classList.remove('transition-on');

        isExpanded = mediaQuery.matches;
    }

    const  mediaQuery = window.matchMedia(`(min-width: ${headerExpanded}px)`);
    resize(mediaQuery);
    mediaQuery.addListener(resize);
    


    /* Attiviamo le transizioni in ritardo
    --------------------------------------------------------------------------*/
    setTimeout(() =>
    {
        context.classList.add('transition-on');
    }, 500);
}


// EXPORT COMPONENTE
//--------------------------------------------------------------------//

export default header;

//--------------------------------------------------------------------//